export default ({ request }) => ({

  getListMyProofing (data = {}) {
    return request({
      url: '/digitalCenter/myProofing/projectList',
      method: 'post',
      data
    })
  }
})
